import {RegistrationPage} from "./views/apps/public/RegistrationPage";
import {LoginPage} from "./views/apps/public/LoginPage";
import ProfilePage from "./views/apps/settings/ProfilePage";
import {LogoutPage} from "./views/apps/public/LogoutPage";
import {NotificationsPage} from "./views/apps/project/backups/notification/NotificationsPage";
import {CompanyPage} from "./views/apps/settings/CompanyPage";
import MembersPage from "./views/apps/settings/MembersPage";
import ConfirmInvitationPage from "./views/apps/public/ConfirmInvitationPage";
import ConfirmEmailPage from "./views/apps/public/ConfirmEmailPage";
import {ResetPasswordPage} from "./views/apps/public/ResetPasswordPage";
import {ResetPasswordRequestPage} from "./views/apps/public/ResetPasswordRequestPage";
import {UserDeleted} from "./components/apps/public/user-deleted/UserDeleted";
import {CompanyDeleted} from "./components/apps/public/company-deleted/CompanyDeleted";
import {NewExportPage} from "./views/apps/project/backups/exports/new/NewExportPage";
import {ConnectionsPage} from "./views/apps/connections/ConnectionsPage";
import {UsagePage} from "./views/apps/usage/UsagePage";
import {BillingPage} from "./views/apps/billing/BillingPage";
import {NewConnectionPage} from "./views/apps/connections/NewConnectionPage";
import {GoogleDriveCallback} from "./views/apps/ouath/GoogleDriveCallback";
import {EditConnectionPage} from "./views/apps/connections/EditConnectionPage";
import {GoogleSheetsCallback} from "./views/apps/ouath/GoogleSheetsCallback";
import {ExportsPage} from "./views/apps/project/backups/exports/ExportsPage";
import {MsExcelCallback} from "./views/apps/ouath/MsExcelCallback";
import {PipedriveCallback} from "./views/apps/ouath/PipedriveCallback";
import {PricingPage} from "./views/apps/public/PricingPage";
import {ContactSalesPage} from "./views/apps/public/ContactSalesPage";
import {JiraCallback} from "./views/apps/ouath/JiraCallback";
import {TemplatesPage} from "./views/apps/templates/TemplatesPage";
import {LoginMicrosoftCallback} from "./views/apps/login/LoginMicrosoftCallback";
import {LoginMicrosoftPage} from "./views/apps/login/LoginMicrosoftPage";
import {DashboardTemplatesPage} from "./views/apps/public/templates/DashboardTemplatesPage";
import {DashboardTemplatePreviewPage} from "./views/apps/public/templates/DashboardTemplatePreviewPage";
import {AIAssistantPage} from "./views/apps/ai-assistant/AIAssistantPage";
import {ChatsPage} from "./views/apps/project/backups/chats/ChatsPage";
import {ChatDetailPage} from "./views/apps/project/backups/chats/detail/ChatDetailPage";
import {CsvSamplesPage} from "./views/apps/public/CsvSamplesPage";
import {ParquetSamplesPage} from "./views/apps/public/ParquetSamplesPage";
import {ViewPage} from "./views/apps/project/backups/view/ViewPage";
import {ViewFilePreviewPage} from "./views/apps/project/backups/view/ViewFilePreviewPage";
import {DatasetsPage} from "./views/apps/project/backups/datasets/DatasetsPage";
import {CsvViewPage} from "./views/apps/public/viewer/CsvViewPage";
import {ExcelViewPage} from "./views/apps/public/viewer/ExcelViewPage";
import {TsvViewPage} from "./views/apps/public/viewer/TsvViewPage";
import {ParquetViewPage} from "./views/apps/public/viewer/ParquetViewPage";
import {JsonViewPage} from "./views/apps/public/viewer/JsonViewPage";
import {TermsAndConditionsPage} from "./views/apps/public/TermsAndConditionsPage";
import {PrivacyPolicyPage} from "./views/apps/public/PrivacyPolicyPage";
import {CookiesPolicyPage} from "./views/apps/public/CookiesPolicyPage";
import {LandingPage} from "./views/apps/public/LandingPage";

const routes = [
    {
        path : "/csv/view",
        component: CsvViewPage,
        private: false,
        template: "public"
    },
    {
        path : "/json/view",
        component: JsonViewPage,
        private: false,
        template: "public"
    },
    {
        path : "/excel/view",
        component: ExcelViewPage,
        private: false,
        template: "public"
    },
    {
        path : "/tsv/view",
        component: TsvViewPage,
        private: false,
        template: "public"
    },
    {
        path : "/parquet/view",
        component: ParquetViewPage,
        private: false,
        template: "public"
    },
    {
        path: "/csv/samples",
        component: CsvSamplesPage,
        template: "public",
        private: false
    },
    {
        path: "/parquet/samples",
        component: ParquetSamplesPage,
        template: "public",
        private: false
    },
    {
        path: "/oauth/microsoft/callback",
        component: LoginMicrosoftCallback,
        template: "public",
        private: false
    },
    {
        path: "/oauth/microsoft/login",
        component: LoginMicrosoftPage,
        private: false,
        template: "connection"
    },
    {
        path: "/connections/oauth/jira/callback",
        component: JiraCallback,
        private: true,
        template: "connection"
    },
    {
        path: "/connections/oauth/google-drive/callback",
        component: GoogleDriveCallback,
        private: true,
        template: "connection"
    },
    {
        path: "/connections/oauth/google-sheets/callback",
        component: GoogleSheetsCallback,
        private: true,
        template: "connection"
    },
    {
        path: "/connections/oauth/ms-excel/callback",
        component: MsExcelCallback,
        private: true,
        template: "connection"
    },
    {
        path: "/connections/oauth/pipedrive/callback",
        component: PipedriveCallback,
        template: "public",
        private: false
    },
    {
        path: "/view/:fileId/preview",
        component: ViewFilePreviewPage,
        private: true,
        template: "default-fullwidth"
    },
    {
        path: "/datasets",
        component: DatasetsPage,
        private: true,
        template: "default"
    },
    {
        path: "/view",
        component: ViewPage,
        private: true,
        template: "default"
    },
    {
        path: "/exports/new",
        component: NewExportPage,
        private: true,
        template: "default"
    },
    {
        path: "/exports/:exportId/ai-assistant",
        component: AIAssistantPage,
        private: true,
        template: "ai"
    },
    {
        path: "/exports/:exportId/:section",
        component: NewExportPage,
        private: true,
        template: "default"
    },
    {
        path: "/exports",
        component: ExportsPage,
        private: true,
        template: "default"
    },
    {
        path: "/chats/:chatId",
        component: ChatDetailPage,
        private: true,
        template: "chats"
    },
    {
        path: "/chats",
        component: ChatsPage,
        private: true,
        template: "default"
    },
    {
        path: "/notifications",
        component: NotificationsPage,
        private: true,
        template: "default"
    },
    {
        path: "/sign-up",
        component: RegistrationPage,
        template: "public"
    },
    {
        path: "/pricing",
        component: PricingPage,
        template: "public"
    },
    {
        path: "/login",
        component: LoginPage,
        template: "public"
    },
    {
        path: "/contact-sales",
        component: ContactSalesPage,
        template: "public"
    },
    {
        path: "/pricing",
        component: PricingPage,
        template: "public"
    },
    {
        path: "/logout",
        component: LogoutPage,
        private: false
    },
    {
        path: "/dashboard-templates/:dashboardTemplateId/preview",
        component: DashboardTemplatePreviewPage,
        private: false,
    },
    {
        path: "/dashboard-templates",
        component: DashboardTemplatesPage,
        private: false
    },
    {
        path: "/reset-password-request",
        component: ResetPasswordRequestPage,
        private: false
    },
    {
        path: "/reset-password",
        component: ResetPasswordPage,
        private: false
    },
    {
        path: "/confirm-email",
        component: ConfirmEmailPage,
        private: false
    },
    {
        path: "/invitation-email",
        component: ConfirmInvitationPage,
        private: false
    },
    {
        path: "/user-deleted",
        component: UserDeleted,
        private: false
    },
    {
        path: "/company-deleted",
        component: CompanyDeleted,
        private: false
    },
    {
        path: "/terms-and-conditions",
        component: TermsAndConditionsPage,
        template: "public"
    },
    {
        path: "/privacy-policy",
        component: PrivacyPolicyPage,
        template: "public"
    },
    {
        path: "/cookies-policy",
        component: CookiesPolicyPage,
        template: "public"
    },
    {
        path: "/users",
        component: MembersPage,
        private: true,
        template: "default"
    },
    // {
    //     path: "/settings/subscriptions",
    //     component: SubscriptionsPage,
    //     private: true,
    //     template: "user"
    // },
    {
        path: "/settings/company",
        component: CompanyPage,
        private: true,
        template: "default"
    },
    {
        path: "/settings",
        component: ProfilePage,
        private: true,
        template: "default"
    },
    {
        path: "/connections/new",
        component: NewConnectionPage,
        private: true,
        template: "connection"
    },
    {
        path: "/connections/edit/:connectionId/:connectionType",
        component: EditConnectionPage,
        private: true,
        template: "connection"
    },
    {
        path: "/connections",
        component: ConnectionsPage,
        private: true,
        template: "default"
    },
    // {
    //     path: "/settings/access-tokens",
    //     component: AccessTokenPage,
    //     private: true,
    //     template: "user"
    // },
    {
        path: "/usage",
        component: UsagePage,
        private: true,
        template: "default"
    },
    {
        path: "/templates",
        component: TemplatesPage,
        private: true,
        template: "default"
    },
    {
        path: "/billing",
        component: BillingPage,
        private: true,
        template: "default"
    },
    {
        path: "/exports",
        component: ExportsPage,
        private: true,
        template: "default"
    },
    {
        path: "/",
        component: LandingPage,
        private: false,
        template: "public"
    }
];

export default routes;